import useAllServicesLoader from './useAllServicesLoader';

import { ReactNode } from 'react';

import { ServiceLoaderResults } from './types';

type WithAllServicesProps = {
  // If `false` this will filter out private service results from the child.
  // It does not prevent the private service request from occuring.
  includePrivate: boolean;
  children: (results: ServiceLoaderResults) => ReactNode;
};

/**
 * Provide all services via render prop.
 * DEPRECATED - use `AllServicesProvider` and `useAllServices` hook instead.
 */
const WithAllServices = ({ includePrivate, children }: WithAllServicesProps) =>
  children(useAllServicesLoader({ includePrivate }));

WithAllServices.defaultProps = { includePrivate: true };

export default WithAllServices;
